export default __webpack_public_path__ + "static/media/012-pirate-ship.508632dd.png";